import React from 'react';
import { determineLinkSvg, iconTypeToSvg } from '../../shop-builder/components/SmartLinkInput';
import type { SocialLink } from '../../shop-builder/types';

interface EditableSocialsProps {
  socials: SocialLink[];
}

function toHref(link: string): string {
  return /^https?:\/\//i.test(link) ? link : `https://${link}`;
}

export default function EditableSocials(props: EditableSocialsProps) {
  return (
    <div className='static-socials'>
      {props.socials.map((social, index) => (
        <a
          key={index}
          href={toHref(social.link)}
          target='_blank'
          rel='noopener noreferrer'
        >
          <img
            src={social.icon_type ? iconTypeToSvg(social.icon_type) : determineLinkSvg(social.link)}
            alt='link'
          />
        </a>
      ))}
    </div>
  );
}
